<template>
    <div class="container-fluid">
        <div class="row scroll" style="width: auto">
            <div class="col-12 col-no-padding">
                <form class="form event-form">
                    <div class="form-row row">
                        <label class="col-12">{{ $t('patrol.planning.form.patrol') }}</label>
                        <select v-model="selectedPatrol" class="form-input col-12">
                            <option v-for="patrol in patrols" :key="patrol.id" :value="patrol.id">{{ patrol.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-row row">
                        <label class="col-12">{{ $t('patrol.planning.form.resource') }}</label>
                        <div class="resource-selector-container" style="width: 100%;z-index: 10"
                             v-on-clickaway="closeResourceSelector">
                            <div class="form-input resource-selector-selection" @click="toggleResourceSelector"><i
                                    class="fa fa-caret-down"></i>{{ selectedResourceLabel }}
                            </div>
                            <div class="resource-selector-wrapper" :class="{show:showResourceSelector}">
                                <ResourceSelector :config="resourceSelectorConfig"
                                                  @change="handleChangeResourcesSelection"

                                ></ResourceSelector>
                            </div>
                        </div>
                    </div>
                    <div class="form-row row">
                        <div class="col-6">
                            <label class="">{{ $t('patrol.planning.form.date') }}</label>
                            <DatePicker v-model="selectedDate" :mini="true" :inputclass="'form-input'"
                                        :position="{v:'top',h:'left'}"></DatePicker>
                        </div>
                        <div class="col-6">
                            <label>{{ $t('patrol.planning.form.time') }}</label>
                            <TimePicker v-model="selectedTime" :mini="true" :inputclass="'form-input'"
                                        :position="{v:'top',h:'right'}"></TimePicker>
                        </div>

                    </div>
                    <div class="form-row row">
                        <label class="col-12">{{ $t('patrol.planning.form.repeat') }}</label>
                        <select class="form-input col-12" v-model="selectedRepeatType">
                            <option value="0">{{ $t('patrol.planning.form.repeat0') }}</option>
                            <option value="1">{{ $t('patrol.planning.form.repeat1') }}</option>
                            <option value="2">{{ $t('patrol.planning.form.repeat2') }}</option>
                            <option value="3">{{ $t('patrol.planning.form.repeat3') }}</option>
                        </select>
                    </div>
                    <div class="form-row row repeat-week-day-container" v-if="selectedRepeatType == 2">
                        <div class="repeat-week-day">
                            <input id="monday" type="checkbox" v-model="selectedRepeatWeekDay[1]">
                            <label for="monday">Lun</label>
                        </div>
                        <div class="repeat-week-day">
                            <input id="tuesday" type="checkbox" v-model="selectedRepeatWeekDay[2]">
                            <label for="tuesday">Mar</label>
                        </div>
                        <div class="repeat-week-day">
                            <input id="wednesday" type="checkbox" v-model="selectedRepeatWeekDay[3]">
                            <label for="wednesday">Mer</label>
                        </div>
                        <div class="repeat-week-day">
                            <input id="thursday" type="checkbox" v-model="selectedRepeatWeekDay[4]">
                            <label for="thursday">Jeu</label>
                        </div>
                        <div class="repeat-week-day">
                            <input id="friday" type="checkbox" v-model="selectedRepeatWeekDay[5]">
                            <label for="friday">Ven</label>
                        </div>
                        <div class="repeat-week-day">
                            <input id="saturday" type="checkbox" v-model="selectedRepeatWeekDay[6]">
                            <label for="saturday">Sam</label>
                        </div>
                        <div class="repeat-week-day">
                            <input id="sunday" type="checkbox" v-model="selectedRepeatWeekDay[0]">
                            <label for="sunday">Dim</label>
                        </div>
                    </div>
                    <div class="form-row row repeat-month-day-container" v-if="selectedRepeatType == 3">
                        <ul class="radio-wrapper">
                            <li class="radio-container">
                                <label for="sameDate">
                                    <input type="radio" id="sameDate" name="repeatMonthDay" value="1"/>
                                    <i class="fa fa-circle-o"></i>
                                    <i class="fa fa-check-circle-o"></i>
                                    Le {{ sameDate }} de chaque mois <i class="fa fa-exclamation-triangle"
                                                                        v-if="isPotentiallyLastDayOfMonth"
                                                                        @mouseover="showTooltipLastDay"
                                                                        @mouseout="hideTooltipLastDay"></i>
                                </label>
                                <div class="tooltip left"
                                     style="width: 134px; top: 4px; left: 208px;line-height: 1rem"
                                     :class="{show:showTooltip.lastDay}">{{ $t('patrol.planning.form.lastDayTooltip') }}
                                </div>
                            </li>
                            <li class="radio-container">
                                <label for="sameDayInMonth">
                                    <input type="radio" id="sameDayInMonth" name="repeatMonthDay" value="2"/>
                                    <i class="fa fa-circle-o"></i>
                                    <i class="fa fa-check-circle-o"></i>
                                    Le {{ sameDayInMonth }} de chaque mois
                                </label>
                            </li>
                            <li class="radio-container" v-if="isPotentiallyLastDayOfMonth">
                                <label for="lastDay">
                                    <input type="radio" id="lastDay" name="repeatMonthDay" value="3"/>
                                    <i class="fa fa-circle-o"></i>
                                    <i class="fa fa-check-circle-o"></i>
                                    Le dernier jour de chaque mois
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="form-row row" v-if="selectedRepeatType != 0">
                        <div class="col-6">
                            <select class="form-input col-12" v-model="selectedRepeatOccurrence">
                                <option value="1">{{ $t('patrol.planning.form.occurrence1') }}</option>
                                <option value="2">{{ $t('patrol.planning.form.occurrence2') }}</option>
                            </select>
                        </div>

                        <div class="col-6" v-if="selectedRepeatOccurrence == 1">
                            <DatePicker v-model="selectedRepeatUntil" :mini="true" :inputclass="'form-input'"
                                        :position="{v:'bottom',h:'right'}"></DatePicker>
                        </div>

                        <div class="col-6" v-if="selectedRepeatOccurrence == 2">
                            <input type="text" class="form-input col-6"/>
                            <span class="col-6">fois</span>
                        </div>

                    </div>
                </form>
            </div>
        </div>
        <Toolbar class="not-fixed">
            <Btn :class="'primary pull-right'" @click.native.stop="valid">
                {{ $t('global.save') }}
            </Btn>
            <Btn :class="'pull-right'" @click.native.stop="cancel">
                {{ $t('global.cancel') }}
            </Btn>
        </Toolbar>
    </div>

</template>

<script>
    import Toolbar from '@/components/ui/Toolbar';
    import Btn from "@/components/ui/Button";

    import ResourceSelector from '@/components/reports/ResourceSelector';
    import DatePicker from '@/components/ui/datetime/DatePicker';
    import TimePicker from '@/components/ui/datetime/TimePicker';

    import {mixin as clickaway} from 'vue-clickaway';

    import moment from 'moment';
    import Utils from '@/services/utils.js'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Toolbar,
            Btn,
            ResourceSelector,
            DatePicker,
            TimePicker
        },
        computed: {
            resourceSelectorConfig: function () {
                return {
                    "type": [
                        "dati",
                        "identification"
                    ],
                    "q": [
                        1,
                        1
                    ]
                }
            },
            selectedResourceLabel: function () {
                if (this.selectedResource) {
                    return this.selectedResource.name;
                }
                return '';
            },
            sameDate() {
                if (this.selectedDate != null) {
                    return this.selectedDate.format('D');
                }
                return "";
            },
            sameDayInMonth() {
                if (this.selectedDate != null) {

                    var nthOfMonth = Math.ceil(this.selectedDate.date() / 7);

                    return Utils.getOrdinal(nthOfMonth) + " " + this.selectedDate.format('dddd');
                }
                return "";
            },
            isPotentiallyLastDayOfMonth() {
                if (this.selectedDate != null) {
                    if (this.sameDate == '28' || this.sameDate == '29' || this.sameDate == '30' || this.sameDate == '31') {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                return false;
            }

        },
        created: function () {

        },
        data() {
            return {
                selectedPatrol: null,
                selectedResource: null,
                selectedResourceType: null,
                selectedDate: null,
                selectedTime: null,
                selectedRepeatType: 0,
                selectedRepeatWeekDay: [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ],
                selectedRepeatUntil: null,
                selectedRepeatOccurrence: 1,

                showResourceSelector: false,
                firstTimeResourceSelector: true,

                showTooltip: {
                    lastDay: false
                }
            }
        },
        destroyed: function () {

        },
        methods: {
            resetForm() {
                this.selectedPatrol = null;
                this.selectedResource = null;
                this.selectedResourceType = null;
                this.selectedDate = null;
                this.selectedTime = null;
                this.selectedRepeatType = 0;
                this.resetRepeatWeek();
                this.selectedRepeatUntil = null;
                this.selectedRepeatOccurrence = 1;

                this.showResourceSelector = false;
                this.firstTimeResourceSelector = true;

                this.showTooltip = {
                    lastDay: false
                }
            },
            resetRepeatWeek(){
                this.selectedRepeatWeekDay = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                ];
            },
            cancel: function () {
                this.resetForm();
                this.$emit('close');
            },
            handleChangeResourcesSelection: function (data) {
                this.selectedResourceType = data.type;
                this.selectedResource = data.values[0];
                this.showResourceSelector = false;
            },
            toggleResourceSelector: function () {
                this.showResourceSelector = !this.showResourceSelector;
                if (this.showResourceSelector) {
                    this.firstTimeResourceSelector = false;
                } else {
                    this.firstTimeResourceSelector = true;
                }
            },
            closeResourceSelector: function () {
                if (this.showResourceSelector && !this.firstTimeResourceSelector) {
                    this.showResourceSelector = false;
                    this.firstTimeResourceSelector = true;
                } else {
                    this.firstTimeResourceSelector = false;
                }
            },
            showTooltipLastDay: function () {
                this.showTooltip.lastDay = true;
            },
            hideTooltipLastDay: function () {
                this.showTooltip.lastDay = false;
            },
        },
        mixins: [clickaway],
        mounted: function () {

        },
        name: '',
        props: {
            patrols: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            date: {
                type: [Object, String],
                default: () => {
                    return null;
                }

            }
        },
        updated: function () {

        },
        watch: {
            date(newVal) {
                if (newVal != null) {
                    var m = moment(newVal);
                    this.selectedDate = m;
                }
            },

            selectedDate(newVal){
                if (newVal != null) {
                    var m = this.selectedDate.clone();
                    this.selectedTime = m.format('HH:mm');
                    this.resetRepeatWeek();
                    this.selectedRepeatWeekDay[m.format('d')] = true;
                    this.selectedRepeatUntil = m.add(1, 'year');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>